import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import type { AuthContextType } from "@/context/AuthContext";

interface MyRouterContext {
  auth: AuthContextType;
}

// Root route ahora solo expone el Outlet.
// El layout global (ThemeProvider + fondo) vive fuera, en main.tsx,
// para evitar frames donde el Outlet queda vacío con fondo en blanco/negro.
export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => <Outlet />,
})